export class DadosInscricao {
  candidato: any;
  agendamento: any;
  vestibular: any;
  tipo: any;
  curso: any;
  turma: any;
  parcelamentoSelected: any;
  parcelamentos: any;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class InscricaoResponse {
  numeroInscricao: string;
  agendamento: {
    predio: string,
    sala: string,
  };

  constructor(args) {
    Object.assign(this, args);
  }
}
